const conversionTypes = {
    ALTITUDE: 'ALTITUDE',
    ANGLE: 'ANGLE',
    ANGLE_RL: 'ANGLE_RL',
    DISTANCE: 'DISTANCE',
    DISTANCE_SHORT: 'DISTANCE_SHORT',
    DISTANCE_EXTRA_SHORT: 'DISTANCE_EXTRA_SHORT',
    DISTANCE_SHORT_FTIN: 'DISTANCE_SHORT_FTIN',
    DISTANCE_LONG: 'DISTANCE_LONG',
    DISTANCE_RL: 'DISTANCE_RL',
    DISTANCE_SHORT_RL: 'DISTANCE_SHORT_RL',
    DISTANCE_EXTRA_SHORT_RL: 'DISTANCE_EXTRA_SHORT_RL',
    DISTANCE_LONG_RL: 'DISTANCE_LONG_RL',
    DISTANCE_SHORT_FTIN_RL: 'DISTANCE_SHORT_FTIN_RL',
    HEIGHT: 'HEIGHT',
    HEIGHT_SHORT: 'HEIGHT_SHORT',
    HEIGHT_SHORT_FTIN: 'HEIGHT_SHORT_FTIN',
    TIME: 'TIME',
    SPEED: 'SPEED',
    SPIN: 'SPIN',
    VELOCITY: 'VELOCITY',
    WIDTH: 'WIDTH',
    WEIGHT: 'WEIGHT',
    PERCENT: 'PERCENT',
    PERMILLE: 'PERMILLE',
    BASISPOINT: 'BASISPOINT',
    NUMBER: 'NUMBER',
    TEMPERATURE: 'TEMPERATURE',
    ACCELERATION: 'ACCELERATION',
};

export default conversionTypes;